
<div class="widthClass">
  <mat-toolbar>
    <h4 class="notice">Select the Probate Court of the City/Town</h4>
  </mat-toolbar>
  <mat-progress-bar *ngIf="loading" mode="query" class="my-color" mode="query" value="value" [bufferValue]="bufferValue">
  </mat-progress-bar>

  <div style="margin:30px;">
    <mat-form-field class="example-full-width">
        <mat-select placeholder="Select Town" [(ngModel)]="townName" required (change)='navigate(townName)'>
            <mat-option *ngFor="let org of organizations" [value]="org.town">
                {{org.town}}
            </mat-option>
        </mat-select>
    </mat-form-field>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/shared/dialog/town-dialog/town-dialog.component.html